import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { isShowResult, onChangeIsShowResult, resultList, lang } = this.props
    return (
      <div
        className={`gashapon-draw-prize-main ${isShowResult ? 'bounceAni' : ''}`}
        style={{ display: `${isShowResult ? "flex" : "none"}` }}>
        <div className="desc">{lang.rwDesc}</div>
        <div className="result-pool-main">
          <div className="reward-main">
            <div className="rw-bg">
              <div className="rw-list">
                {
                  resultList.map((item, index) => {
                    return (
                      <div className={`rw-item come${index + 1}`} key={item.id}>
                        <div className="bubble">
                          <img src={item.bubbleUrl} alt="" />
                          <div className="count">x{item.winNum}</div>
                        </div>
                        <div className="gift">
                          <img src={item.image} style={{ transform: `${item.image.indexOf('egg_fragment') > 0 ? 'scale(0.75)' : ''}` }} />
                        </div>
                        <div className="shadow"></div>
                        <div className="name">{item.name}</div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
          <div className={`close ${isShowResult ? 'close-ani' : ''}`} onClick={() => { onChangeIsShowResult() }}></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/gashapon/ResultPopUp/index.js